import React, { useState } from 'react';
import { SearchBar } from './SearchBar';

interface CommonPromptBoxProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  placeholder?: string;
  className?: string;
  variant?: 'glass' | 'hero' | 'light' | 'permit';
  inputRef?: React.Ref<HTMLTextAreaElement>;
  leftSlot?: React.ReactNode;
  submitIcon?: React.ReactNode;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  maxHeight?: number;
  onDragOver?: (event: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave?: (event: React.DragEvent<HTMLDivElement>) => void;
  onDrop?: (event: React.DragEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

export const CommonPromptBox: React.FC<CommonPromptBoxProps> = ({
  className,
  maxHeight = 560,
  disabled,
  ...rest
}) => {
  const [isMultiLine, setIsMultiLine] = useState(false);

  const mergedClassName = `${className || ''}${isMultiLine ? ' searchbox--multiline' : ''}`.trim();

  return (
    <SearchBar
      {...rest}
      disabled={disabled}
      maxHeight={maxHeight}
      className={mergedClassName}
      onHeightChange={(_, scrollHeight) => setIsMultiLine(scrollHeight > 52)}
    />
  );
};

export default CommonPromptBox;
